// Components/VisitorsAnalytics.js
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { FaArrowUp, FaArrowDown, FaCalendarAlt } from 'react-icons/fa';

// Sample data
const sampleData = [
  { name: 'Jan', visitors: 4000 },
  { name: 'Feb', visitors: 3000 },
  { name: 'Mar', visitors: 5000 },
  { name: 'Apr', visitors: 4000 },
  { name: 'May', visitors: 6000 },
  { name: 'Jun', visitors: 7000 },
  { name: 'Jul', visitors: 8000 },
  { name: 'Aug', visitors: 9000 },
  { name: 'Sep', visitors: 10000 },
  { name: 'Oct', visitors: 11000 },
  { name: 'Nov', visitors: 12000 },
  { name: 'Dec', visitors: 13000 }
];

const VisitorsAnalytics = () => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
        <FaCalendarAlt className="text-blue-600" /> Visitors Analytics
      </h3>
      <div className="h-64">
        <ResponsiveContainer>
          <LineChart data={sampleData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="visitors" stroke="#4A90E2" strokeWidth={2} dot={{ stroke: '#4A90E2', strokeWidth: 2, r: 4 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div className="bg-gray-100 p-4 rounded-lg shadow-md flex items-center gap-3">
          <FaArrowUp className="text-green-500 text-2xl" />
          <div className="truncate">
            <h4 className="text-sm font-semibold text-gray-700 mb-1 truncate">Total Visitors</h4>
            <p className="text-gray-900 text-xl font-bold truncate">120,000</p>
          </div>
        </div>
        <div className="bg-gray-100 p-4 rounded-lg shadow-md flex items-center gap-3">
          <FaArrowDown className="text-red-500 text-2xl" />
          <div className="truncate">
            <h4 className="text-sm font-semibold text-gray-700 mb-1 truncate">Average Daily Visitors</h4>
            <p className="text-gray-900 text-xl font-bold truncate">4,000</p>
          </div>
        </div>
        <div className="bg-gray-100 p-4 rounded-lg shadow-md flex items-center gap-3">
          <FaCalendarAlt className="text-yellow-500 text-2xl" />
          <div className="truncate">
            <h4 className="text-sm font-semibold text-gray-700 mb-1 truncate">Peak Month</h4>
            <p className="text-gray-900 text-xl font-bold truncate">December</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisitorsAnalytics;
